import { getFileBase64 } from "./getFileBase64";

export const getFilePreview = async (file: File): Promise<string> => {
  // TODO: 对于视频文件改成提取首帧的逻辑
  const base64 = await getFileBase64(file);
  return base64;
};
